const TEXT_FILE = 'txt';
const ZIP_FILE = 'zip';

export {
    TEXT_FILE, ZIP_FILE
}